export const empty = () => ({
    title: null,
    search: {
        query: null,
        facetState: {}
    }
})
